// src/components/CustomCursor.js - NATIVO
const CustomCursor = () => {
  return null; // Cursor nativo corporativo
};

export default CustomCursor;
